/*
 * Collapsible Image Defer
 * RTE images inside collapsed product tabs (description, size charts) render
 * src-less — snippets/tab.liquid rewrites src/srcset to data-src/data-srcset —
 * because collapsed accordions are height-0 and Chrome fetches their images
 * despite loading="lazy". This hydrates them on first open, capping Shopify CDN
 * images to width=1000 (RTE images ship as full-size masters otherwise).
 *
 * THEME UPDATE NOTE:
 * If theme is updated, re-add this line to layout/theme.liquid in <head>,
 * with the other custom scripts before theme.js:
 *   <script src="{{ 'collapsible-image-defer.js' | asset_url }}" defer="defer"></script>
 */

(function() {
  'use strict';

  var WIDTH_CAP = '1000'; // accordion content column is < 1000px at every breakpoint

  // Matches both Shopify CDN URL shapes: cdn.shopify.com/s/files/... and
  // <shop-domain>/cdn/shop/files/... (which form a store gets varies).
  var SHOPIFY_CDN = /\/cdn\/shop\/|cdn\.shopify\.com/;

  function hydrate(img) {
    var srcset = img.getAttribute('data-srcset');
    if (srcset) { img.srcset = srcset; img.removeAttribute('data-srcset'); }
    var src = img.getAttribute('data-src');
    if (!src) return;
    if (SHOPIFY_CDN.test(src) && !/[?&]width=/.test(src)) {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + WIDTH_CAP;
    }
    // theme.js measures the accordion's height before these images have
    // dimensions (RTE imgs ship without width/height attrs) — once each image
    // lands, re-assert auto height so nothing stays clipped.
    img.addEventListener('load', function() {
      var content = img.closest('.collapsible-content');
      if (content && content.classList.contains('is-open')) {
        content.style.height = 'auto';
      }
    }, { once: true });
    img.src = src;
    img.removeAttribute('data-src');
  }

  // Capture phase: start the fetches before theme.js's own trigger handler
  // (bound on the trigger element) measures and animates the accordion.
  document.addEventListener('click', function(evt) {
    var trigger = evt.target.closest('.collapsible-trigger');
    if (!trigger) return;
    var id = trigger.getAttribute('aria-controls');
    var target = id && document.getElementById(id);
    if (!target) return;
    target.querySelectorAll('img[data-src]').forEach(hydrate);
  }, true);
})();
